import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Map } from 'leaflet';

interface SearchOptions {
  provinceId?: number;
  branchId?: number;
  cityId?: number;
}

interface MapState {
  loading: boolean;
  searchLoading: boolean;
  viewSearchLoading: boolean;
  polygonList: any[];
  createTemp?: any;
  createFinish?: any;
  editTemp?: any;
  editFinish?: any;
  map?: Map;
  needFlyTo?: any;
  zoomLevel: number;
  selectedBranch?: any;
  createMarkerTemp?: any;
  searchOptions: SearchOptions;
  layersList?: any;
  layersListLoading: boolean;
  selectedLayers: any[];
  lastSelectedLayerId?: number;
  searchResults?: any[];
  showCityPolygon?: any;
  invisiblePinIds?: any[];
}

const localStorageSelectedLayers = localStorage.getItem('selectedLayers');

const initialState: MapState = {
  loading: false,
  searchLoading: false,
  viewSearchLoading: false,
  polygonList: [],
  createTemp: undefined,
  createFinish: undefined,
  editTemp: undefined,
  editFinish: undefined,
  map: undefined,
  needFlyTo: undefined,
  zoomLevel: 10,
  selectedBranch: undefined,
  createMarkerTemp: undefined,
  searchOptions: {},
  layersList: undefined,
  layersListLoading: false,
  selectedLayers: localStorageSelectedLayers ? JSON.parse(localStorageSelectedLayers) : [1],
  lastSelectedLayerId: undefined,
  searchResults: undefined,
};

export const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setMapSearchResult: (state, { payload }) => {
      state.searchResults = payload;
    },
    // setMapPolygonPins: (state, { payload }) => {
    //   //make a unique list of pins of state.polygonList and payload
    //   const list = state.polygonPins || [];
    //   payload.map((polygon) => {
    //     let isAvailable = false;
    //     list.map((item, index) => {
    //       if (item.id === polygon.id) {
    //         isAvailable = true;
    //         list[index] = polygon;
    //       }
    //     });
    //     !isAvailable && list.push(polygon);
    //   });
    //   state.polygonPins = [...list];
    // },
    setMapShowCityPolygon: (state, { payload }) => {
      state.showCityPolygon = payload;
    },
    // setMapCityPolygonDetail: (state, { payload }) => {
    //   state.cityPolygonDetail = payload;
    // },
    // setMapSelectedHisoryDate: (state, { payload }) => {
    //   state.selectedHistoryDate = payload;
    // },
    // setMapHistoryMode: (state, { payload }) => {
    //   state.historyMode = payload;
    // },
    // setMapHistoryList: (state, { payload }) => {
    //   if (!payload) return;
    //   const list = state.historyList || [];
    //   payload.map((polygon) => {
    //     let isAvailable = false;
    //     list.map((item, index) => {
    //       if (item.branchId === polygon.branchId) {
    //         isAvailable = true;
    //         list[index] = polygon;
    //       }
    //     });
    //     !isAvailable && list.push(polygon);
    //   });
    //   state.historyList = [...list];
    // },
    // clearMapHistoryList: (state) => {
    //   state.historyList = undefined;
    // },
    // clearMapBranchHistoryList: (state) => {
    //   state.branchHistoryList = undefined;
    // },
    // closeMapHistoryMode: (state) => {
    //   state.historyMode = false;
    //   state.historyList = undefined;
    //   state.branchHistorySelectedIndex = 0;
    //   state.branchHistoryList = undefined;
    //   state.selectedHistoryDate = undefined;
    // },
    // setMapBranchHistoryList: (state, { payload }) => {
    //   state.branchHistoryList = payload;
    // },
    // setBranchHistorySelectedIndex: (state, { payload }) => {
    //   state.branchHistorySelectedIndex = payload;
    // },
    setMapSearchLoading: (state, { payload }) => {
      state.searchLoading = payload;
    },
    setMapViewSearchLoading: (state, { payload }) => {
      state.viewSearchLoading = payload;
    },
    setPolygonResetPolygonList: (state) => {
      state.polygonList = [];
    },
    setMapCreateMarkerTemp: (state, { payload }) => {
      state.createMarkerTemp = payload;
    },
    // setPolygonList: (state, { payload }) => {
    //   payload.map((polygon) => {
    //     let isAvailable = false;

    //     state.polygonList.map((item, index) => {
    //       if (item.id === polygon.id) {
    //         isAvailable = true;
    //         state.polygonList[index] = polygon;
    //       }
    //     });
    //     !isAvailable && state.polygonList.push(polygon);
    //   });
    // },
    removePlygonFromList: (state, { payload }) => {
      state.polygonList = state.polygonList.filter((item) => item.id !== payload);
    },
    replaceMapPolygon: (state, { payload }) => {
      const index = state.polygonList.findIndex((item) => item.branchTitle === payload.branchTitle && item.layerId === payload.layerId);
      state.polygonList[index] = payload;
    },
    setMapCreateTemp: (state, { payload }) => {
      state.createTemp = payload;
    },
    setMapEditTemp: (state, { payload }) => {
      state.editTemp = payload;
    },
    // setMapEditingPolygon: (state, { payload }) => {
    //   state.editingPolygon = payload;
    // },
    // setMapCreatingPolygon: (state, { payload }) => {
    //   state.creatingPolygon = payload;
    // },
    setMapCreateFinish: (state, { payload }) => {
      state.createFinish = payload;
    },
    setMapEditFinish: (state, { payload }) => {
      state.editFinish = payload;
    },
    setMap: (state, { payload }) => {
      state.map = payload;
    },
    setMapNeedFlyTo: (state, { payload }) => {
      state.needFlyTo = payload;
    },
    setMapZoomLevel: (state, { payload }) => {
      state.zoomLevel = payload;
    },
    setMapSelectedBranch: (state, { payload }) => {
      state.selectedBranch = payload;
    },
    setMapSearchOptions: (state, { payload }) => {
      state.searchOptions = payload;
    },
    setmapLayersList: (state, { payload }) => {
      state.layersList = payload;
    },
    setMapLayersListLoading: (state, { payload }) => {
      state.layersListLoading = payload;
    },
    setMapSelectedLayers: (state, { payload }) => {
      localStorage.setItem('selectedLayers', JSON.stringify(payload));
      state.selectedLayers = payload;
    },
    setMapLastSelectedLayerId: (state, { payload }) => {
      state.lastSelectedLayerId = payload;
    },
    // setMapCopyingLayer: (state, { payload }) => {
    //   state.copyingLayer = payload;
    // },
    // toggleMapLayerSetting: (state) => {
    //   state.colorSetting = state.colorSetting === 'layer' ? 'branchesType' : 'layer';
    // },
    clearMapPolygonList: (state) => {
      state.polygonList = [];
    },
    setInvisiblePinIds: (state, { payload }) => {
      state.invisiblePinIds = payload;
    },
  },
});

export const {
  setMapSearchResult,
  setLoading,
  //   setMapPolygonPins,
  //   setMapBranchHistoryList,
  //   setBranchHistorySelectedIndex,
  //   setMapHistoryList,
  //   setMapHistoryMode,
  setMapSearchLoading,
  setMapCreateMarkerTemp,
  setMapViewSearchLoading,
  setPolygonResetPolygonList,
  setMapZoomLevel,
  //   setPolygonList,
  removePlygonFromList,
  replaceMapPolygon,
  setMapCreateTemp,
  setMapEditTemp,
  //   setMapEditingPolygon,
  //   setMapCreatingPolygon,
  setMapCreateFinish,
  setMapEditFinish,
  setMap,
  setMapNeedFlyTo,
  setMapSelectedBranch,
  setMapSearchOptions,
  setmapLayersList,
  setMapLayersListLoading,
  setMapSelectedLayers,
  setMapLastSelectedLayerId,
  //   setMapCopyingLayer,
  //   toggleMapLayerSetting,
  //   setMapSelectedHisoryDate,
  //   closeMapHistoryMode,
  //   clearMapBranchHistoryList,
  //   clearMapHistoryList,
  setMapShowCityPolygon,
  //   setMapCityPolygonDetail,
  clearMapPolygonList,
  setInvisiblePinIds,
} = mapSlice.actions;
export default mapSlice.reducer;
